/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".university-filter__validation-message[_ngcontent-%COMP%]{margin:.5em 0 .2em;max-width:200px;font-size:13px;font-weight:500;color:#c15959;line-height:1.24;overflow-wrap:break-word}"];
export { styles as styles };
